import React, { useEffect, useState } from "react";
import { get_seriecomprobantes_by_terminalcajero_tipocomprobante } from "../../../actions/comprobante";
import { SelectUi } from "../../ui/SelectUi";
import { Form } from "antd";
export const SerieComprontesSelect = ({
  terminalcajero,
  tipocomprobante,
  ...props
}) => {
  const form = Form.useFormInstance();
  const [serieComprobantes, setSerieComprobantes] = useState([]);

  useEffect(() => {
    const OnLoadSerieComprobantes = async (terminalcajero, tipocomprobante) => {
      const data =
        await get_seriecomprobantes_by_terminalcajero_tipocomprobante(
          terminalcajero,
          tipocomprobante,
        );
      const datos = data?.map((x) => ({
        label: x.seriecomprobante,
        value: x.seriecomprobante,
      }));
      setSerieComprobantes(datos);
      form.setFieldValue("seriecomprobante", datos?.[0]?.value);
    };
    if (
      typeof terminalcajero !== "undefined" &&
      typeof tipocomprobante !== "undefined" &&
      tipocomprobante !== null
    )
      OnLoadSerieComprobantes(terminalcajero, tipocomprobante);
  }, [terminalcajero, tipocomprobante]);

  return <SelectUi data={serieComprobantes} {...props} />;
};
